import { UPDATE_EMPLOYEE_SUCCESS, showNotification } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

export function updateEmployeeSuccessEpic(action$) {
    return action$.pipe(
        ofType(UPDATE_EMPLOYEE_SUCCESS),
        mergeMap(() => {

            return of(showNotification('Die Speicherung des Mitarbeiters war erfolgreich.'));
        })
    );
}
